import React, { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../components/Footer";
import Nav from "../components/Navbar";
import SEO from "../components/SEO";
import { useParams } from "react-router-dom";
import "./PublicTourListing.css";

// Import Swiper CSS
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const PublicTourListing = () => {
    const { token } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const BACKEND_URL = process.env.REACT_APP_API_URL;

    const API_URL = `${BACKEND_URL}/guide-listing/public-listing/${token}`;

    useEffect(() => {
        const fetchData = async () => {
        try {
            const res = await axios.get(API_URL);
            setData(res.data.data);
        } catch (err) {
            setError("Guide Listing not found or expired!");
        } finally {
            setLoading(false);
        }
        };
        fetchData();
    }, [token, API_URL]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p className="error">{error}</p>;

    const { tour, guide } = data;
    const tourTitle = tour?.title || "Tour Package";
    const guideName = guide?.name || "Local Guide";
    const tourImage = guide?.logo || "https://soloway.lk/logo.png";
    const description = tour?.description || `Explore ${tour?.service_area || "Sri Lanka"} with certified local guide ${guideName}.`;

    const tourSchema = {
      "@context": "https://schema.org",
      "@type": "TouristTrip",
      "name": tourTitle,
      "description": description,
      "touristType": ["Adventure", "Cultural", "Eco-Tourism", "Sightseeing"],
      "image": tourImage,
      "offers": {
        "@type": "Offer",
        "price": tour?.price,
        "priceCurrency": "LKR",
        "availability": "https://schema.org/InStock",
        "url": `https://soloway.lk/public-tour-listing/${token}`
      },
      "provider": {
        "@type": "Person",
        "name": guideName,
        "jobTitle": "Certified Sri Lankan Tour Guide",
        "knowsAbout": guide?.specialty || "Sri Lanka Tourism",
        "knowsLanguage": guide?.languages || "English"
      }
    };

    return (
    <>
        <SEO 
          title={`${tourTitle} by ${guideName}`}
          description={description.substring(0, 160)}
          canonicalPath={`/public-tour-listing/${token}`}
          ogImage={tourImage}
          schemaJson={tourSchema}
        />
        <Nav/>
        <div className="container">
        <h3 className="listing-title">Guide Listing of {guide.name}</h3>

        {guide.logo && (
            <div className="image-container">
          <img
            src={guide.logo}
            alt={`Guide logo of ${guide.name}`}
            style={{
                width: "100%",
                height: "360px",
                objectFit: "cover",
                borderRadius: "12px",
            }}
        />

            </div>
        )}

        <hr />

        <h3>Tour Details:</h3>
        <p className="hotel-label"><strong>Tour Name:</strong> {tour.title}</p>
        <p className="roomType"><strong>Tour Service Area:</strong> {tour.service_area}</p>
        <p className="maxGuests"><strong>Maximum People:</strong> {tour.max_people} People</p>
        <p className="price-tag">LKR {tour.price}</p>
        <p className="description">{tour.description}</p>

        <hr />

        {tour.inclusions?.length > 0 && (
            <>
            <h3>Inclusions: </h3>
            <div>
                {tour.inclusions.map((inc, i) => (
                <span key={i} className="amenity-badge">{inc}</span>
                ))}
            </div>
            </>
        )}

        <hr /><br />

        <div className="card">
            <h3>Guide Information:</h3>
            <p><strong>Name:</strong> {guide.name}</p>
            <p><strong>Languages:</strong> {guide.languages}</p>
            <p><strong>Experience:</strong> {guide.experience} years</p>
            <p><strong>Specialty:</strong> {guide.specialty}</p>
        </div>

        <hr />

        <h3>Reviews & Ratings:</h3>
        {tour.reviews?.length > 0 ? (
            tour.reviews.map((review, index) => (
            <div key={index} className="review-card">
                <p>⭐ {review.rating}</p>
                <p>{review.comment}</p>
            </div>
            ))
        ) : (
            <p>No reviews yet</p>
        )}
        </div>
        <Footer/>
    </>
    );
};

export default PublicTourListing;
